module.exports = __webpack_public_path__ + "img/photo-0146.735c1134.jpg";